module.exports = __webpack_public_path__ + "img/sunrise.42bb831.png";